qaPresenter.controller('qaPresenterCtrl', [
    '$rootScope',
    '$scope',
    'logService',
    'questionService',
    'notificationService',
    'localizationService',
    function ($rootScope, $scope, logService, questionService, notificationService, localizationService) {
        var self = this;
        const logger = logService.createLoggerWithSource('qaPresenterCtrl');

        self.inQAMode = false;
        self.currentQuestion = {};
        self.isQAModeActive = isQAModeActive;
        self.getQuestions = getQuestions;
        self.stopQA = stopQA;
        self.returnToList = returnToList;
        self.hideControls = false;

        self.activeIndex = 0;
        self.getActiveQuestion = getActiveQuestion;
        self.nextQuestion = nextQuestion;
        self.isOnLastQuestion = isOnLastQuestion;

        $rootScope.$on('start-qa-mode', onStartedQandAMode);
        $rootScope.$on('stop-qa-mode', onStoppedQandAMode);
        $rootScope.$on('promoted-to-presenter', onPromotedToPresenter);
        $rootScope.$on('demoted-to-attendee', onDemotedToAttendee);
        $rootScope.$on('fs-connection-complete', onFSConnectionComplete);

        ////////////////////////

        function onFSConnectionComplete(evt) {
            self.hideControls = false;
        }

        function onPromotedToPresenter(evt) {
            self.hideControls = true;
        }

        function onDemotedToAttendee(evt) {
            self.hideControls = true;
        }

        function onStartedQandAMode(evt, question) {
            questionService.setCurrentQuestion(question);
            if (!questionService.getIsInQandAMode()) {
                notificationService.show(localizationService.translate('Q_AND_A.QANDA_MODE_STARTED'), 'success');
            }
            questionService.setIsInQandAMode(true);
            digest();
        }

        function onStoppedQandAMode() {
            questionService.setIsInQandAMode(false);
            notificationService.show(localizationService.translate('Q_AND_A.QANDA_MODE_ENDED'), 'success');
            digest();
        }

        function isQAModeActive() {
            return questionService.getIsInQandAMode() && !self.hideControls;
        }

        function getQuestions() {
            return questionService.getNewQuestions();
        }

        function getActiveQuestion() {
            return questionService.getCurrentQuestion();
        }

        function nextQuestion() {
            questionService.nextQuestion();
        }

        function isOnLastQuestion() {
            return questionService.isOnLastQuestion();
        }

        function stopQA() {
            questionService.stopQandAMode();
        }

        function returnToList() {
            logger.log('Returning to Q&A list');
            $rootScope.$broadcast('show-modal', 'webinarPresenterQA');
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
